import { createDebugger } from '@iotize/common/debug';
const prefix = '@iotize/common/zip';
export const debug = createDebugger(prefix);
